import React from 'react'
import { Link } from 'react-router-dom'
import * as routes from '../../../constants/routes'

const Logo = () =>
    <Link to={routes.HOME}>
        <div className="logo" />
    </Link>

export default Logo